import React from 'react';
import { useDispatch } from 'react-redux';

import { EditAppointmentIcon } from 'features/order-tracker/shared-components/svg';
import { initAmendAppointmentFlow } from 'features/order-tracker/store/actions';

import styles from './styles.module.scss';

export const AmendAppointmentButton: React.FC<components.AmendAppointmentButton> = ({
  itemId,
  orderKey,
  currentAppointmentDate,
  originAppointmentDate,
  text,
}) => {
  const dispatch = useDispatch();

  const handleClick = (): void => {
    dispatch(
      initAmendAppointmentFlow({
        currentAppointmentDate,
        originAppointmentDate,
        itemId,
        orderKey,
      }),
    );
  };

  return text ? (
    <button type="button" onClick={handleClick} className={styles.button}>
      <EditAppointmentIcon />
      {text}
    </button>
  ) : (
    <></>
  );
};
